import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import FormField from 'app/components/form/FormField';
import { formatNum } from 'app/utils';

interface IFormattedNumberField {
    name: string;
    className?: string;
}

export const FormattedNumberField = (props: IFormattedNumberField) => {
    const { errors, touched, values, setFieldValue } = useFormikContext();
    const [displayValue, setDisplayValue] = useState<string>('');
    const [isEditing, setIsEditing] = useState<boolean>(false);

    const error = (errors as any)[props.name];
    const touch = (touched as any)[props.name];
    const value = (values as any)[props.name];

    useEffect(() => {
        if (!isEditing) {
            // Format for display when not editing
            setDisplayValue(value ? formatNum(value) : '');
        }
    }, [value, isEditing]);

    const handleFocus = () => {
        setIsEditing(true);
        // Show raw number when editing
        setDisplayValue(value?.toString() || '');
    };

    const handleBlur = () => {
        setIsEditing(false);
        // Parse and save the value
        if (displayValue === '' || displayValue.trim() === '') {
            // Clear the field value when input is empty
            setFieldValue(props.name, null);
        } else {
            const numValue = parseFloat(displayValue.replace(/\./g, '').replace(',', '.'));
            if (!isNaN(numValue)) {
                setFieldValue(props.name, numValue);
            }
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDisplayValue(e.target.value);
    };

    return (
        <FormField className={props.className} error={error} touched={touch}>
            <input
                type="text"
                name={props.name}
                value={displayValue}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onChange={handleChange}
            />
        </FormField>
    );
};